module.exports = __webpack_public_path__ + "static/img/refresh.397b3aaf.png";